module.exports = __webpack_public_path__ + "static/media/Account_Activated.ea00b67d.png";